const configure = {
    stripe_test:"pk_test_51PaI48I9ILgHFhfd6P6r84ljXzy6q2344JAoLsJHZNj5UHK1lL6WWYMyh0MQ9ARaP0oDw3TK5Qj1olZW50dmrDOH00cOWW2tUH",
    stripe_live:"pk_live_51PaI48I9ILgHFhfdrYUIw1zD3H61xE9HAwtTBipNhdjRoZfMIfpBdpCXAyddM8j8KkgsYsOWV4yNChrKtMOUjJCW004HGnXqsJ"
}

export default configure